import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Content.css';
import Button from '../../Button/Button';

const SimpleContent: React.FC<SimpleContent> = ({ title, body, footNote, hasMoreInfo, moreInfoSrc }) => { //moreInfoSrc
    const [showFirst, setShowFirst] = useState(true);

    const handleToggle = () => {
        setShowFirst(prev => !prev);
    };


    return (
        <AnimatePresence mode="wait">
            <div className='tileContent'>
                <h2 className='tileTitle'>{title}</h2>
                <p className='tileDescription'>
                    {body}
                </p>
                <p className='tileFootnote'>
                    {footNote}
                </p>

                {showFirst ? (
                    <motion.div
                        key="first"
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 50 }}
                        transition={{ duration: 1 }}
                    >
                        <>
                            {hasMoreInfo ? (
                                <Button name="MoreInfo" text="More Info" type="" onClick={handleToggle} />
                            ) : (<></>)}
                        </>
                    </motion.div>
                ) : (
                    <motion.div
                        key="second"
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 50 }}
                        transition={{ duration: 1 }}
                    >
                        <img className='moreInfoImg' src={moreInfoSrc == null ? "" : moreInfoSrc} />
                    </motion.div>
                )}


            </div>
        </AnimatePresence>

    );
};

export default SimpleContent;